export default __webpack_public_path__ + "static/media/systemowe2.fe4c6ff6.jpg";